import {MobileAccordion} from 'components/accordion';

const collapseMenuList = Array.from(document.querySelectorAll('.j-collapse-menu'));

collapseMenuList.forEach((elem) => {
    new MobileAccordion().init({
        elem,
        selectors: {
            toggler     : '.j-collapse-menu__title',
            content     : '.j-collapse-menu__list',
            contentOuter: '.j-collapse-menu__list-outer'
        }
    });
});
